module.exports = __webpack_public_path__ + "static/media/logo-footer.1f86b1b8.png";